// Mock data for Dispensers of Grace Ministry website

export const BRAND = {
  name: 'Dispensers of Grace Ministry',
  short: 'Dispensers of Grace',
  tagline: 'God Prescribes His Word, We Dispense It.',
  logo: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_base44-interactive/artifacts/ija8ft7k_DOGM%20LOGO.png',
  founderPhoto: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_base44-interactive/artifacts/zxki0x4e__MY%20PASSPORT%20PHOTO%20NEW.jpg',
  welcomeVideo: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_base44-interactive/artifacts/o6foudrv_WELCOME_TO_DISPENSERS_OF_GRACE_MINISTRY_.mp4',
  promoVideo: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_base44-interactive/artifacts/zfgls6hc_promo_video_for_dispensers_of_grace_ministry%20%281%29.mp4',
  email: 'info@dispensersofgrace.org',
  phone: '+44 7590 407268',
  address: 'Dispensers of Grace Ministry',
  youtube: 'https://www.youtube.com/live/pRDESMKjDU8?si=x31hVeEzTL84G3zt',
  youtubeEmbed: 'https://www.youtube.com/embed/pRDESMKjDU8',
  whatsapp: 'https://wa.me/447590407268?text=Grace%20and%20peace%2C%20I%27d%20love%20to%20connect%20with%20Dispensers%20of%20Grace%20Ministry.',
  whatsappCommunity: 'https://chat.whatsapp.com/DispensersOfGraceDailyDosage',
  whatsappNumber: '+447590407268',
};

// Change this passcode to control who can access /admin uploads
export const ADMIN_PASSCODE = 'grace2025';

export const HERO_IMAGES = {
  bibleSunrise: 'https://images.unsplash.com/photo-1593485589800-579b43749b15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxiaWJsZSUyMHN1bnJpc2V8ZW58MHx8fHwxNzg3OTUwNTc3fDA&ixlib=rb-4.1.0&q=85',
  bibleSunrise2: 'https://images.unsplash.com/photo-1533000971552-6a962ff0b9f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxiaWJsZSUyMHN1bnJpc2V8ZW58MHx8fHwxNzg3OTUwNTc3fDA&ixlib=rb-4.1.0&q=85',
  crossSunset: 'https://images.unsplash.com/photo-1592818868295-f527dbac420d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjcm9zcyUyMHN1bnNldHxlbnwwfHx8fDE3ODc5NTA1Nzd8MA&ixlib=rb-4.1.0&q=85',
  crossSunset2: 'https://images.unsplash.com/photo-1450558415837-1f5e21a17709?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxjcm9zcyUyMHN1bnNldHxlbnwwfHx8fDE3ODc5NTA1Nzd8MA&ixlib=rb-4.1.0&q=85',
  crossSunset3: 'https://images.unsplash.com/photo-1617610882105-71c5d7447837?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxjcm9zcyUyMHN1bnNldHxlbnwwfHx8fDE3ODc5NTA1Nzd8MA&ixlib=rb-4.1.0&q=85',
  worshipHands: 'https://images.unsplash.com/photo-1438232992991-995b7058bbb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHx3b3JzaGlwJTIwaGFuZHN8ZW58MHx8fHwxNzg3OTUwNTc4fDA&ixlib=rb-4.1.0&q=85',
  worshipHands2: 'https://images.unsplash.com/photo-1611513940806-80d6ed9fd7cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHx3b3JzaGlwJTIwaGFuZHN8ZW58MHx8fHwxNzg3OTUwNTc4fDA&ixlib=rb-4.1.0&q=85',
  prayingHands: 'https://images.unsplash.com/photo-1457139621581-298d1801c832?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxwcmF5aW5nJTIwaGFuZHN8ZW58MHx8fHwxNzg3OTUwNTc4fDA&ixlib=rb-4.1.0&q=85',
  prayingHands2: 'https://images.unsplash.com/photo-1437603568260-1950d3ca6eab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxwcmF5aW5nJTIwaGFuZHN8ZW58MHx8fHwxNzg3OTUwNTc3fDA&ixlib=rb-4.1.0&q=85',
  congregation: 'https://images.unsplash.com/photo-1478147427282-58a87a120781?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjaHVyY2glMjBjb25ncmVnYXRpb258ZW58MHx8fHwxNzg3OTUwNTc3fDA&ixlib=rb-4.1.0&q=85',
  congregation2: 'https://images.unsplash.com/photo-1565813086292-604790c8a97b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxjaHVyY2glMjBjb25ncmVnYXRpb258ZW58MHx8fHwxNzg3OTUwNTc3fDA&ixlib=rb-4.1.0&q=85',
  bibleStudy: 'https://images.unsplash.com/photo-1576506542790-51244b486a6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxiaWJsZSUyMHN0dWR5fGVufDB8fHx8MTc4Nzk1MDU3N3ww&ixlib=rb-4.1.0&q=85',
  bibleStudy2: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxiaWJsZSUyMHN0dWR5fGVufDB8fHx8MTc4Nzk1MDU3N3ww&ixlib=rb-4.1.0&q=85',
};

export const VISION_MISSION = {
  intro: 'Dispenser of Grace Ministry is an interdenominational Christian ministry committed to carrying and communicating the transforming power of God\u2019s grace to the world. In a generation searching for answers, we believe God has already written the prescription. His Word is the divine formula for healing, freedom, restoration, and transformation. When received and applied, it changes everything.',
  vision: 'Every life has a divine prescription. God, the Great Physician, has already written it \u2014 His Word, His power, and His grace.',
  mission: 'We believe that the same God who gave the prescription has entrusted us to dispense it with love, wisdom, and the power of the Holy Spirit until every heart encounters the fullness of His grace.',
};

export const MANDATES = [
  {
    title: 'Holiness',
    text: 'Cultivating set-apart lives that reflect the character of Christ in every place He has planted us.',
    icon: 'Flame',
  },
  {
    title: 'Leadership',
    text: 'Raising Christ-centred leaders equipped to serve the Body of Christ and shape their world with the Word.',
    icon: 'Compass',
  },
  {
    title: 'Marriage',
    text: 'Building Christ-honouring marriages \u2014 covenants of love, grace, and purpose that outlast every storm.',
    icon: 'HeartHandshake',
  },
  {
    title: 'Youth Development',
    text: 'Discipling the next generation with the fire of the Spirit, sound doctrine, and a heart for God\u2019s purpose.',
    icon: 'Sparkles',
  },
  {
    title: 'Evangelism',
    text: 'Dispensing the gospel of grace boldly and warmly \u2014 that every soul may encounter the fullness of Jesus.',
    icon: 'Megaphone',
  },
];

export const PILLARS = [
  {
    title: 'Love',
    verse: '1 John 4:19',
    text: 'We love because He first loved us. The love of Christ compels every act of service, every prayer, every embrace.',
    icon: 'Heart',
  },
  {
    title: 'Grace',
    verse: 'Ephesians 2:8',
    text: 'By grace you have been saved, through faith \u2014 and this not from yourselves; it is the gift of God.',
    icon: 'Gift',
  },
  {
    title: 'Hope',
    verse: 'Romans 15:13',
    text: 'May the God of hope fill you with all joy and peace as you trust in Him, so that you may overflow with hope.',
    icon: 'Sunrise',
  },
  {
    title: 'Holiness',
    verse: '1 Peter 1:16',
    text: 'Be holy, because I am holy. A set-apart life brings glory to God and light to a watching world.',
    icon: 'Flame',
  },
];

export const DAILY_DOSAGES = [
  {
    id: 'd1',
    date: 'Today',
    title: 'The Prescription of Grace',
    verseRef: '2 Corinthians 12:9',
    verse: 'My grace is sufficient for you, for my power is made perfect in weakness.',
    body: 'Grace is not a small dose reserved for a distant heaven \u2014 it is a daily prescription for the weary soul. Whatever burden you carry into today, the Great Physician has already written the remedy. Receive it, and dispense it to another.',
    author: 'Pastor Oladipo Babalola',
    minutes: 3,
    image: 'https://images.unsplash.com/photo-1593485589800-579b43749b15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxiaWJsZSUyMHN1bnJpc2V8ZW58MHx8fHwxNzg3OTUwNTc3fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'd2',
    date: 'Yesterday',
    title: 'Walking In the Light',
    verseRef: '1 John 1:7',
    verse: 'But if we walk in the light, as He is in the light, we have fellowship with one another.',
    body: 'Light exposes, but it also heals. To walk with Christ is to step out of the shadows of shame and into a community that carries one another home.',
    author: 'Pastor Oladipo Babalola',
    minutes: 4,
    image: 'https://images.unsplash.com/photo-1450558415837-1f5e21a17709?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxjcm9zcyUyMHN1bnNldHxlbnwwfHx8fDE3ODc5NTA1Nzd8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'd3',
    date: '2 days ago',
    title: 'When Hope Feels Distant',
    verseRef: 'Psalm 42:11',
    verse: 'Why, my soul, are you downcast? Put your hope in God, for I will yet praise Him.',
    body: 'Hope is not a feeling that arrives \u2014 it is a Person to whom we turn. Speak to your soul today, and remind it of the faithfulness of the God who has never once let you fall.',
    author: 'Pastor Oladipo Babalola',
    minutes: 3,
    image: 'https://images.unsplash.com/photo-1533000971552-6a962ff0b9f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxiaWJsZSUyMHN1bnJpc2V8ZW58MHx8fHwxNzg3OTUwNTc3fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'd4',
    date: '3 days ago',
    title: 'A Holy People, A Loved People',
    verseRef: '1 Peter 2:9',
    verse: 'But you are a chosen people, a royal priesthood, a holy nation, God\u2019s special possession.',
    body: 'Holiness is not a fence that keeps you from joy \u2014 it is the very shape of a life fully alive in Christ. You are chosen. You are loved. Walk worthy today.',
    author: 'Pastor Oladipo Babalola',
    minutes: 4,
    image: 'https://images.unsplash.com/photo-1592818868295-f527dbac420d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjcm9zcyUyMHN1bnNldHxlbnwwfHx8fDE3ODc5NTA1Nzd8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'd5',
    date: '4 days ago',
    title: 'The Word That Heals',
    verseRef: 'Psalm 107:20',
    verse: 'He sent out His word and healed them; He rescued them from the grave.',
    body: 'The Word of God is medicine for the soul \u2014 not merely information, but the very breath of the One who spoke light into darkness. Take it daily.',
    author: 'Pastor Oladipo Babalola',
    minutes: 3,
    image: 'https://images.unsplash.com/photo-1504052434569-70ad5836ab65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxiaWJsZSUyMHN0dWR5fGVufDB8fHx8MTc4Nzk1MDU3N3ww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'd6',
    date: '5 days ago',
    title: 'Compelled by Love',
    verseRef: '2 Corinthians 5:14',
    verse: 'For Christ\u2019s love compels us, because we are convinced that one died for all.',
    body: 'Love is the fuel of every dispenser of grace. When the world feels heavy, let the cross remind you: you were loved first, and now you love because of Him.',
    author: 'Pastor Oladipo Babalola',
    minutes: 3,
    image: 'https://images.unsplash.com/photo-1438232992991-995b7058bbb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHx3b3JzaGlwJTIwaGFuZHN8ZW58MHx8fHwxNzg3OTUwNTc4fDA&ixlib=rb-4.1.0&q=85',
  },
];

export const TEACHINGS = [
  {
    id: 't1',
    title: 'Welcome to Dispensers of Grace Ministry',
    speaker: 'Pastor Oladipo Babalola',
    duration: '02:14',
    series: 'Welcome',
    thumbnail: 'https://images.unsplash.com/photo-1593485589800-579b43749b15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxiaWJsZSUyMHN1bnJpc2V8ZW58MHx8fHwxNzg3OTUwNTc3fDA&ixlib=rb-4.1.0&q=85',
    videoUrl: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_base44-interactive/artifacts/o6foudrv_WELCOME_TO_DISPENSERS_OF_GRACE_MINISTRY_.mp4',
    description: 'A warm welcome to our ministry family. Discover our heart, our mission, and how the Word of God is being dispensed daily to a hurting world.',
    isLocal: true,
  },
  {
    id: 't2',
    title: 'The Promise: A Ministry Vision',
    speaker: 'Pastor Oladipo Babalola',
    duration: '01:48',
    series: 'Vision',
    thumbnail: 'https://images.unsplash.com/photo-1450558415837-1f5e21a17709?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxjcm9zcyUyMHN1bnNldHxlbnwwfHx8fDE3ODc5NTA1Nzd8MA&ixlib=rb-4.1.0&q=85',
    videoUrl: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_base44-interactive/artifacts/zfgls6hc_promo_video_for_dispensers_of_grace_ministry%20%281%29.mp4',
    description: 'A stirring promotional glimpse into what God is doing through Dispensers of Grace Ministry \u2014 a call to encounter Jesus and walk in His grace.',
    isLocal: true,
  },
  {
    id: 't3',
    title: 'Sufficient Grace for Every Season',
    speaker: 'Pastor Oladipo Babalola',
    duration: '38:22',
    series: 'Grace Series',
    thumbnail: 'https://images.unsplash.com/photo-1533000971552-6a962ff0b9f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxiaWJsZSUyMHN1bnJpc2V8ZW58MHx8fHwxNzg3OTUwNTc3fDA&ixlib=rb-4.1.0&q=85',
    description: 'When strength fails, grace remains. A message from 2 Corinthians on drawing daily from the well of Christ\u2019s sufficiency.',
  },
  {
    id: 't4',
    title: 'Walking in Holiness Without Legalism',
    speaker: 'Pastor Oladipo Babalola',
    duration: '42:07',
    series: 'Holiness Series',
    thumbnail: 'https://images.unsplash.com/photo-1592818868295-f527dbac420d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjcm9zcyUyMHN1bnNldHxlbnwwfHx8fDE3ODc5NTA1Nzd8MA&ixlib=rb-4.1.0&q=85',
    description: 'How to pursue a set-apart life fueled by love, not fear \u2014 and how the Spirit produces true fruit in ordinary lives.',
  },
  {
    id: 't5',
    title: 'When Prayer Feels Silent',
    speaker: 'Pastor Oladipo Babalola',
    duration: '35:14',
    series: 'Prayer Foundations',
    thumbnail: 'https://images.unsplash.com/photo-1457139621581-298d1801c832?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxwcmF5aW5nJTIwaGFuZHN8ZW58MHx8fHwxNzg3OTUwNTc4fDA&ixlib=rb-4.1.0&q=85',
    description: 'The heavens are not closed. A tender word for the soul that has cried out and heard only echoes.',
  },
  {
    id: 't6',
    title: 'The Hope That Anchors',
    speaker: 'Pastor Oladipo Babalola',
    duration: '31:48',
    series: 'Hope Series',
    thumbnail: 'https://images.unsplash.com/photo-1617610882105-71c5d7447837?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxjcm9zcyUyMHN1bnNldHxlbnwwfHx8fDE3ODc5NTA1Nzd8MA&ixlib=rb-4.1.0&q=85',
    description: 'From Hebrews 6 \u2014 an unshakeable hope for storms that will not seem to end.',
  },
  {
    id: 't7',
    title: 'Love One Another As I Have Loved You',
    speaker: 'Pastor Oladipo Babalola',
    duration: '29:56',
    series: 'Love Series',
    thumbnail: 'https://images.unsplash.com/photo-1611513940806-80d6ed9fd7cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHx3b3JzaGlwJTIwaGFuZHN8ZW58MHx8fHwxNzg3OTUwNTc4fDA&ixlib=rb-4.1.0&q=85',
    description: 'The measure of Christian love \u2014 not sentiment, but sacrifice modeled at the cross.',
  },
  {
    id: 't8',
    title: 'The Word Made Flesh',
    speaker: 'Pastor Oladipo Babalola',
    duration: '44:12',
    series: 'Christ Central',
    thumbnail: 'https://images.unsplash.com/photo-1576506542790-51244b486a6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxiaWJsZSUyMHN0dWR5fGVufDB8fHx8MTc4Nzk1MDU3N3ww&ixlib=rb-4.1.0&q=85',
    description: 'A study of John 1 \u2014 the eternal Word who entered our story to bring us home.',
  },
];

export const EVENTS = [
  {
    id: 'e1',
    title: 'Dispensers of Grace Seminars',
    date: 'Quarterly',
    time: 'See announcements',
    location: 'Online + In-Person (venue announced per quarter)',
    description: 'Four times a year we gather for deep, teaching-rich seminars unpacking the Scriptures for practical, Christ-centred living.',
    tag: 'Quarterly',
    series: 'Dispensers of Grace Seminars',
  },
  {
    id: 'e2',
    title: 'Liberation Night Vigil',
    date: 'Every Second Friday of the month',
    time: '11:00 PM \u2013 2:00 AM (GMT)',
    location: 'Online \u00b7 Zoom & YouTube Live',
    description: 'A monthly night of worship, the Word, and travailing prayer \u2014 believing God for breakthrough, freedom, and healing.',
    tag: 'Monthly',
    series: 'Liberation Night Vigil',
  },
  {
    id: 'e3',
    title: 'Dosage For Today',
    date: 'Daily',
    time: 'Sent every morning',
    location: 'WhatsApp (join to receive)',
    description: 'A daily Scripture-rooted devotional posted every day on our WhatsApp community \u2014 a fresh dose of grace for your soul.',
    tag: 'Daily',
    series: 'Dosage For Today',
  },
  {
    id: 'e4',
    title: 'Youth Fire Conference',
    date: 'Twice a Year',
    time: 'See announcements',
    location: 'Online + In-Person',
    description: 'A conference for young hearts \u2014 for empowerment, encounter, and equipping the next generation to walk in Christ.',
    tag: 'Youth',
    series: 'Youth Fire Conference',
  },
];

export const TESTIMONIALS = [
  {
    id: 'ts1',
    name: 'Grace A.',
    role: 'London, UK',
    quote: 'The daily dosages have become my morning bread. I feel like I finally understand what it means to walk in grace \u2014 not perform for it.',
  },
  {
    id: 'ts2',
    name: 'Samuel O.',
    role: 'Lagos, Nigeria',
    quote: 'This ministry restored my hope in Christ when I had none left. Every teaching goes straight to the heart of the matter \u2014 Jesus.',
  },
  {
    id: 'ts3',
    name: 'Maria D.',
    role: 'S\u00e3o Paulo, Brazil',
    quote: 'I found a family here. The prayers, the Word, the love \u2014 it is real. God is truly dispensing His grace through this ministry.',
  },
];

export const FOUNDER = {
  name: 'Pastor Oladipo Babalola',
  role: 'Founder & Senior Minister',
  photo: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_base44-interactive/artifacts/zxki0x4e__MY%20PASSPORT%20PHOTO%20NEW.jpg',
  short: 'A husband, father, teacher of the Word, and shepherd of souls \u2014 called to dispense the grace of Christ to every generation.',
  long: [
    'Pastor Oladipo Babalola is the founder and senior minister of Dispensers of Grace Ministry \u2014 a Christ-centred, interdenominational ministry raised to help people encounter Jesus, understand the Word, and live holy, purposeful lives.',
    'For over two decades he has served the Body of Christ across nations, teaching the Bible with clarity, warmth, and a deep pastoral heart. His conviction is simple: God has already prescribed His Word, and it is our joy \u2014 our sacred assignment \u2014 to dispense it to a world in need of healing.',
    'He is happily married to Pastor Mrs Bosede Babalola and, alongside their family, gives himself daily to prayer, the ministry of the Word, and the shepherding of souls into the fullness of Christ.',
  ],
};

export const FOUNDERS = [
  {
    name: 'Pastor Oladipo Babalola',
    role: 'Founder & Senior Minister',
    photo: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_base44-interactive/artifacts/zxki0x4e__MY%20PASSPORT%20PHOTO%20NEW.jpg',
    bio: 'A shepherd of souls with a deep pastoral heart, called to dispense the grace of Christ through the ministry of the Word, prayer, and biblical teaching to a generation in need of healing.',
  },
  {
    name: 'Pastor Mrs Bosede Babalola',
    role: 'Co-Founder',
    photo: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_base44-interactive/artifacts/au1d21qs_BOSEDE.jpg',
    bio: 'A devoted wife, mother, and minister of the gospel \u2014 co-labouring in prayer, teaching, and the shepherding of women and families into the fullness of Christ.',
  },
];
